import React, { useState, useEffect } from 'react';
import TR from './../../Trans';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import BDialog from './BDialog';
import Grid from '@mui/material/Grid';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

function EditPlayList(props) {

  const [playListName, setPlayListName] = useState("");

  useEffect(() => { 
    setPlayListName(props.playListName ? props.playListName : "");
  }, [props.open])

  const handleKeyDown = (event) => {
if (event.key === 'Enter') {
      props.onPlayListEdit(playListName);
    }
  };

  return (
    <BDialog openToLeft={true} disableRestoreFocus open={props.open} onKeyDown={handleKeyDown} onClose={props.onClose}>
      <DialogTitle>{TR.cm_save}</DialogTitle>
      <DialogContent>
        <InputLabel>{TR.cm_name}</InputLabel>
        <TextField
          autoFocus
          margin="dense"
          type="text"
          defaultValue={props.playListName ? props.playListName : ""}
          fullWidth
          onChange={(e) => setPlayListName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="secondary" onClick={props.onClose}>{TR.cm_cancel}</Button>
          <Button
            color="success"
            className="muvika-dialog-action-right"
            onClick={() => props.onPlayListEdit(playListName)}>{TR.cm_save}</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default EditPlayList;